import { render, staticRenderFns } from "./UnitKpiBoxes.vue?vue&type=template&id=6908f56c&scoped=true"
import script from "./UnitKpiBoxes.vue?vue&type=script&lang=js"
export * from "./UnitKpiBoxes.vue?vue&type=script&lang=js"
import style0 from "./UnitKpiBoxes.vue?vue&type=style&index=0&id=6908f56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908f56c",
  null
  
)

export default component.exports